module.exports = __webpack_public_path__ + "img/dialog_bg.e7afab23.png";